
    const cssAssetMap = {};
    const injectedCssHrefs = new Set();
    const exposeLoadPromises = new Map();

    // Shared and remote readiness is handled by explicit Promise barriers below
    // and by remoteEntry's pendingShareLoads barrier. Keep this map scoped to a
    // single expose: unrelated exposes must stay independent and load in parallel.
    function loadExposedModule(exposeKey, loader) {
      let load = exposeLoadPromises.get(exposeKey);
      if (!load) {
        load = Promise.resolve()
          .then(loader)
          .catch((error) => {
            exposeLoadPromises.delete(exposeKey);
            throw error;
          });
        exposeLoadPromises.set(exposeKey, load);
      }
      return load;
    }

    async function injectCssAssets(exposeKey) {
      if (typeof document === "undefined") {
        return;
      }

      // Replaced at build time with expose -> css asset paths.
      const cssAssets = cssAssetMap[exposeKey] || [];

      await Promise.all(
        cssAssets.map((cssAsset) => {
          const href = new URL(cssAsset, import.meta.url).href;

          // Same expose can be resolved multiple times in one page.
          if (injectedCssHrefs.has(href)) {
            return Promise.resolve();
          }
          injectedCssHrefs.add(href);

          // Check for any existing stylesheet with the same href, not just
          // MF-injected ones. This prevents duplicate <link> tags when Vite's
          // own CSS module injection or MF runtime's createLink has already
          // created a <link rel="stylesheet"> for the same URL.
          const existingLink = document.querySelector(
            `link[rel="stylesheet"][href="${href}"]`
          );
          if (existingLink) {
            return Promise.resolve();
          }

          return new Promise((resolve, reject) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            link.onload = () => resolve();
            link.onerror = () => reject(new Error(`[Module Federation] Failed to load CSS asset: ${href}`));
            document.head.appendChild(link);
          });
        })
      );
    }

    export default {
    
        "./Context": async () => {
          await injectCssAssets("./Context")
          await Promise.all([import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_CareJourneyNetworkBrowser__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending),import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_NetworkRegistry__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending),import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_ReferralIndex__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending)])
          const importModule = await loadExposedModule(
            "./Context",
            () => import("./src/exposed/Context.tsx")
          )
          const dependencyPending = importModule && importModule.__mf_remote_dependency_pending;
          if (dependencyPending && typeof dependencyPending.then === "function") {
            await dependencyPending;
          }
          const exportModule = {}
          Object.assign(exportModule, importModule)
          
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./ClientDemographics": async () => {
          await injectCssAssets("./ClientDemographics")
          await Promise.all([import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_CareJourneyNetworkBrowser__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending),import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_NetworkRegistry__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending),import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_ReferralIndex__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending)])
          const importModule = await loadExposedModule(
            "./ClientDemographics",
            () => import("./src/exposed/ClientDemographics.tsx")
          )
          const dependencyPending = importModule && importModule.__mf_remote_dependency_pending;
          if (dependencyPending && typeof dependencyPending.then === "function") {
            await dependencyPending;
          }
          const exportModule = {}
          Object.assign(exportModule, importModule)
          
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./Messaging": async () => {
          await injectCssAssets("./Messaging")
          await Promise.all([import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_CareJourneyNetworkBrowser__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending),import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_NetworkRegistry__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending),import("virtual:mf:__mfe_internal__careco__loadRemote__thoth_mf_1_ReferralIndex__mf_owner__1__loadRemote__.js")
            .then((mod) => mod.__mf_remote_pending)])
          const importModule = await loadExposedModule(
            "./Messaging",
            () => import("./src/exposed/Messaging.tsx")
          )
          const dependencyPending = importModule && importModule.__mf_remote_dependency_pending;
          if (dependencyPending && typeof dependencyPending.then === "function") {
            await dependencyPending;
          }
          const exportModule = {}
          Object.assign(exportModule, importModule)
          
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./ProgressBar": async () => {
          await injectCssAssets("./ProgressBar")
          await Promise.all([])
          const importModule = await loadExposedModule(
            "./ProgressBar",
            () => import("./src/exposed/ProgressBar.tsx")
          )
          const dependencyPending = importModule && importModule.__mf_remote_dependency_pending;
          if (dependencyPending && typeof dependencyPending.then === "function") {
            await dependencyPending;
          }
          const exportModule = {}
          Object.assign(exportModule, importModule)
          
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      
  }
  